import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import { FilterMatchMode } from 'primereact/api';
import { errorMessage, NormalMessage, successMessage } from "../../utils/alertMessage";
import { formatDate, formatDateWithTime } from "../../constants/FormateDate";
import { getLeadType, getUserLead, getUserLeadStatus } from "../../services/leads";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { replaceUnderscoresWithSpacesAndUpperCase } from "../../components/Regex";
import { Calendar } from "primereact/calendar";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { getUser } from "../../services/userMasterUser";
import { MCubeCall } from "../../services/MCubeCall";

export default function CourseReport() {

    const navigate = useNavigate();

    const ds = useRef(null);

    const location = useLocation();
    const isFirstRender = useRef(true);

    const { userProfileData } = getUserData();

    const [products, setProducts] = useState([]);

    const [totalRecords, setTotalRecords] = useState(0);
    let dataLimitValue = localStorage.getItem("dataLimit") || 500;
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(dataLimitValue);
    const [loadingMore, setLoadingMore] = useState(false);


    const [startDateValue, setStartDateValue] = useState(null);
    const [endDateValue, setEndDateValue] = useState(null);

    const [showFilters, setShowFilters] = useState(false);


    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        mobile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        quires: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        address: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    });

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [showTodayFollowup, setShowTodayFollowup] = useState(false);

    const searchByStatusData = [
        { label: "Name", value: "name" },
        { label: "Mobile", value: "mobile" },
        { label: "Quires", value: "quires" },
        { label: "Address", value: "address" },
    ]

    const recordTypeSelection = [
        { label: "CreatedOn", value: "CreatedOn" },
        { label: "LeadOn", value: "LeadOn" },
        { label: "FollowUpOn", value: "FollowUpOn" },
        { label: "ClosedOn", value: "ClosedOn" }]

    const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
    const [leadTypeList, setLeadTypeList] = useState([])
    const [userDataFilter, setUserDataFilter] = useState("");
    const [userDataFilterInfo, setUserDataFilterInfo] = useState({});
    const [userDataIds, setUserDataIds] = useState([]);



    const [searchByStatus, setSearchByStatus] = useState('name');

    const typeData = {
        searchBy: "",
        searchText: "",
        limit: dataLimitValue,
        offset: 0,
        sortBy: "",
        sortOrder: "desc",
        statusIn: [],
        sourceIn: [],
        userIdIn: [userDataFilter], // selection of userData

        recordType: recordTypeValue,
        startDate: "",
        endDate: "",
        leadTypeIn: ["course"],
        userLeadStatusIn: ["ASSIGN", "WORKING", "ASSIGN_TO_OTHER", "DONE"]
    };

    const fetchData = (data, append = false) => {
        setLoadingMore(true);

        getUserLead(data)
            .then((response) => {
                if (!response.data.error) {

                    const rawData = response.data.data || response.data;

                    // 🔥 Extract only the lead object
                    // const newData = rawData.map(item => item.lead);

                    if (append) {
                        setProducts((prev) => [...(prev || []), ...rawData]);
                    } else {
                        setProducts(rawData);
                    }

                    setTotalRecords(response.data.totalRecords || rawData.length);
                    setShowTodayFollowup(false);
                } else {
                    errorMessage("Invalid Credentials");
                }
            })
            .catch(() => {
                errorMessage();
            })
            .finally(() => {
                setLoadingMore(false);
            });
    };

    const [userLeadStatus, setUserLeadStatus] = useState([])
    const [selectedUserLeadStatus, setSelectedUserLeadStatus] = useState("");

    const fetchUserLeadStatus = () => {

        getUserLeadStatus()
            .then((response) => {
                if (!response.data.error) {

                    const rawData = response.data.data || response.data;
                    const newDataIds = rawData.map(item => ({
                        label: item, value: item
                    }));
                    setUserLeadStatus(newDataIds)
                } else {
                    errorMessage("Invalid Credentials");
                }
            })
            .catch(() => {
                errorMessage();
            })
    };

    useEffect(() => {

        const userData = {
            searchBy: "",
            searchText: "",
            limit: 1000,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            userTypeIdIn: [],
            roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
            statusIn: ["ACTIVE"]

        };

        getUser(userData)
            .then((response) => {
                if (!response.data.error) {
                    const newData = response.data.data || response.data; // adjust if API structure differs
                    const newDataId = newData.map(item => item.id);
                    const newDataIds = newData.map(item => ({
                        label: item.userName + " - " + item?.userTypeInfo, value: item.id
                    }));

                    if (location.state?.listState) {
                        const { products, first, rows } = location.state.listState;

                        setProducts(products);
                        setFirst(first);
                        setRows(rows);
                    } else {
                        fetchData({
                            ...typeData,
                            userIdIn: [newDataId[0]],
                            limit: rows,
                            offset: 0
                        });
                    }

                    setUserDataIds(newDataIds)
                }
            })
            .catch(() => {
                errorMessage();
            })

        getLeadType()
            .then((response) => {
                if (!response.data.error) {
                    const leadStatus = response.data.map((item) => ({
                        label: item,
                        value: item,
                    }));
                    setLeadTypeList(leadStatus);
                }
            })
            .catch(() => errorMessage());

        fetchUserLeadStatus()

    }, []);

    useEffect(() => {

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        let startDate = "";
        let endDate = "";

        if (startDateValue) {
            startDate = new Date(startDateValue);
            endDate = endDateValue ? new Date(endDateValue) : new Date();
        }

        // Check if any filter exists
        const hasValidFilter =
            selectedUserLeadStatus ||
            recordTypeValue ||
            startDateValue ||
            endDateValue;

        if (!hasValidFilter) return;

        // if (selectedUserLeadStatus !== "") {

        fetchData({
            ...typeData,
            limit: rows,
            offset: 0,
            userLeadStatusIn: selectedUserLeadStatus ? [selectedUserLeadStatus] : ["ASSIGN", "WORKING", "ASSIGN_TO_OTHER", "DONE"],
            recordType: recordTypeValue,
            startDate,
            endDate,
            userIdIn: userDataFilter ? [userDataFilter] : [],
            leadTypeIn: ["course"]
        });
        // }
    }, [selectedUserLeadStatus, recordTypeValue, startDateValue, endDateValue, userDataFilter]);

    const handleTelecallerDepartment = (id) => {
        setUserDataFilter(id)

        const currentUserinfo = userDataIds.filter(item => (
            item.value === id
        ))
        setUserDataFilterInfo(currentUserinfo)
    }

    const loadMore = () => {
        const newOffset = first + rows;

        fetchData(
            {
                ...typeData,
                limit: rows,
                offset: newOffset
            },
            true // append mode
        );

        setFirst(newOffset);
    };

    const onFilter = (event) => {
        setFilters(event.filters);

        let searchBy = "";
        let searchText = "";

        // Detect which column filter is applied
        Object.keys(event.filters).forEach((key) => {
            if (key !== "global" && event.filters[key]?.value) {
                searchBy = key;
                searchText = event.filters[key].value;
            }
        });

        fetchData({
            searchBy,
            searchText,
            limit: dataLimitValue,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            statusIn: [],
            sourceIn: [],
            userIdIn: [userDataFilter]
        });
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;

        setGlobalFilterValue(value);
        setFirst(0);
        setProducts([]);

        fetchData({
            searchBy: searchByStatus,
            searchText: value,
            limit: dataLimitValue,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            statusIn: [],
            userIdIn: [userDataFilter]
        });
    };

    const itemTemplate = (data) => {
        return (
            <div>
            </div>
        )
    }

    const OrderStatusColors = [
        "#3EB3E1",
        "#866CCE",
        "#F5C43A",
        "#09B4AA",
        "#55BD5A",
        "#FF6767",
        "#5D53D8",
        "#6EA4F5",
        "#E89534",
        "#a906c2",
        "#3EB3E1",
        "#866CCE",
        "#F5C43A",
        "#09B4AA",
        "#55BD5A",
        "#FF6767",
        "#5D53D8",
        "#6EA4F5",
        "#E89534",
        "#a906c2",
        "#3EB3E1",
        "#866CCE",
        "#F5C43A",
        "#09B4AA",
        "#55BD5A",
        "#FF6767",
        "#5D53D8",
        "#6EA4F5",
        "#E89534",
        "#a906c2",
        "#3EB3E1",
        "#866CCE",
        "#F5C43A",
        "#09B4AA",
        "#55BD5A",
        "#FF6767",
        "#5D53D8",
        "#6EA4F5",
        "#E89534",
        "#a906c2",
        "#000",
    ];

    function formatIndianShort(value) {
        if (value == null || isNaN(value)) return "";

        const num = Number(value);

        if (num >= 10000000) {
            return (num / 10000000).toFixed(num % 10000000 === 0 ? 0 : 1) + "Cr";
        }

        if (num >= 100000) {
            return (num / 100000).toFixed(num % 100000 === 0 ? 0 : 1) + "L";
        }

        return num.toLocaleString("en-IN");
    }

    const productMap = Object.groupBy(products, item => item.lead.status);

    const result = Object.entries(productMap).map(([status, items]) => ({
        status,
        amount: items.reduce((sum, item) => sum + item.lead.amount, 0),
        count: items.length
    }));

    const totalAmount = products
        ?.reduce((sum, item) => sum + (item?.lead?.amount || 0), 0);

    const today = new Date().toISOString().split("T")[0];

    // const todayLeads = products?.filter(item => {
    //     const createdDate = item?.leadInfoList?.find(
    //         leadInfo => leadInfo?.keyName === "createdDate"
    //     )?.dateValue;

    //     return (
    //         createdDate &&
    //         new Date(createdDate).toISOString().split("T")[0] === today
    //     );
    // });

    const todayLeads = products?.filter(item => {
        const createdDate = item?.leadInfoList?.find(
            leadInfo => leadInfo?.keyName === "createdDate"
        )?.dateValue;

        const isToday =
            createdDate &&
            new Date(createdDate).toISOString().split("T")[0] === today;

        const isReceive =
            item?.lead?.status?.trim().toUpperCase() === "RECEIVE";

        const isASSIGN =
            item?.lead?.status?.trim().toUpperCase() === "ASSIGN";

        return isToday || isReceive || isASSIGN;
        // return isToday;
    });

    const todayLeadsAmount = todayLeads?.reduce(
        (sum, item) => sum + (item?.lead?.amount || 0),
        0
    );

    const nextFollowUpDateLeads = products?.filter(item => {
        const nextFollowUpDate = item?.leadInfoList?.find(
            leadInfo => leadInfo?.keyName === "nextFollowUpDate"
        )?.dateValue;

        return (
            nextFollowUpDate &&
            new Date(nextFollowUpDate).toISOString().split("T")[0] === today
        );
    });

    // 1. Add this state near your other useState declarations
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [showTodayLeads, setShowTodayLeads] = useState(false);

    // 2. Replace your existing tableData line with this:
    // const tableData = (() => {
    //     let data = showTodayFollowup ? nextFollowUpDateLeads : products;
    //     if (selectedStatus) {
    //         data = data.filter(item => item.lead?.status === selectedStatus);
    //     }
    //     return data;
    // })();


    // const tableData = (() => {
    //     let data = showTodayFollowup ? nextFollowUpDateLeads : products;
    //     if (selectedStatus) {
    //         data = data.filter(item => {
    //             const actionStatus = item?.leadInfoList?.find(
    //                 leadInfo => leadInfo?.keyName === "actionOnLead"
    //             )?.textValue;

    //             return (
    //                 actionStatus?.trim()?.toLowerCase() ===
    //                 selectedStatus?.trim()?.toLowerCase()
    //             );
    //         });
    //     }
    //     return data;
    // })();

    const tableData = (() => {

        // Today Leads filter
        if (showTodayLeads) {
            return todayLeads;
        }

        // Today Followup filter
        if (showTodayFollowup) {
            return nextFollowUpDateLeads;
        }

        // Status filter
        if (selectedStatus) {
            return products.filter(item => {
                const actionStatus = item?.leadInfoList?.find(
                    leadInfo => leadInfo?.keyName === "actionOnLead"
                )?.textValue;

                return (
                    actionStatus?.trim()?.toLowerCase() ===
                    selectedStatus?.trim()?.toLowerCase()
                );
            });
        }

        return products;
    })();

    const disbursementLoanData = result.find(
        (item) => item.status === "disbursement"
    );


    const statusList = [
        // { label: "RECEIVE", value: "RECEIVE" },
        { label: "in process", value: "in process" },
        { label: "work assign to operation", value: "work assign to operation" },
        { label: "work include", value: "work include" },
        { label: "hold for follow up", value: "hold for follow up after sometime" },
        { label: "call not pick up", value: "call not pick up" },
        { label: "not interested", value: "not interested" },
        { label: "not doable", value: "not doable" },
        // { label: "complete", value: "complete" },
    ];

    const resultNew = statusList.map(statusItem => {
        const matchingItems = products.filter(item => {
            const actionStatus = item?.leadInfoList?.find(
                leadInfo => leadInfo?.keyName === "actionOnLead"
            )?.textValue;

            return (
                actionStatus?.trim()?.toLowerCase() ===
                statusItem.value.trim().toLowerCase()
            );
        });

        return {
            status: statusItem.label,
            count: matchingItems.length,
            amount: matchingItems.reduce(
                (sum, item) => sum + Number(item?.lead?.amount || 0),
                0
            )
        };
    });

    // const resultNew = statusList.map(statusItem => {
    //     const matchingItems = products.filter(
    //         item =>
    //             item?.lead?.status?.trim().toLowerCase() ===
    //             statusItem.value.trim().toLowerCase()
    //     );

    //     return {
    //         status: statusItem.label,
    //         count: matchingItems.length,
    //         amount: matchingItems.reduce(
    //             (sum, item) => sum + (item?.lead?.amount || 0),
    //             0
    //         )
    //     };
    // });


    const handleMcubeCall = (selectedItem) => {

        const data = {
            httpAuthorization: userProfileData?.mcubeAuthToken,
            exeNumber: userProfileData?.mobile,
            custNumber: selectedItem?.lead?.mobileNo
        }

        if (userProfileData?.mcubeAuthToken && userProfileData?.mobile && selectedItem?.lead?.mobileNo) {
            MCubeCall(data)
                .then((response) => {
                    const Res = response.data;
                    // handle the response
                    NormalMessage(Res.msg);
                })
                .catch((error) => {
                    // handle errors
                    errorMessage("Failed");
                });
        } else {
            errorMessage(
                [
                    !userProfileData?.mcubeAuthToken && "Mcube Auth Token Is Not Present",
                    !userProfileData?.mobile && "User Mobile Number Is Not Present",
                    !selectedItem?.lead?.mobileNo && "Customer Mobile Is Not Present",
                ]
                    .filter(Boolean)
                    .join("<br/>")
            );
        }
    }

    return (
        <main id="main" className="main">
            <section className="section main-color">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-main">
                            <div className="card-body">
                                <div
                                    style={{
                                        alignItems: "center",
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                <h5 className="card-title flex">
                                    <div
                                        className="mr-3 cursor-pointer"
                                        onClick={() => navigate("/")}
                                    >
                                        <i class="bi bi-arrow-left-circle-fill"></i>
                                        </div> Course Report
                                    
                                </h5>
                                <i
                                    className="pi pi-filter-fill"
                                    onClick={() => setShowFilters(!showFilters)}
                                    style={{ color: "#1e439b" }}
                                ></i>
                                    </div>
                                {/* <div class="kpi-grid" id="kpi-grid">
                                    <div class="kpi-card">
                                        <div class="kpi-accent" style={{ background: "#1a6b32" }}></div>
                                        <div class="kpi-icon-wrap" style={{ background: "#e8f5ed" }}><i class="pi pi-users" style={{ color: "#1a6b32", fontSize: '20px' }}></i></div>
                                        <div class="kpi-label">Today Leads</div>
                                        <div class="kpi-val" id="kpi-total">{todayLeads?.length}</div>
                                        <div class="kpi-sub">All time</div>
                                    </div>

                                    <div class="kpi-card">
                                        <div class="kpi-accent" style={{ background: "#2b6cb0" }}></div>
                                        <div class="kpi-icon-wrap" style={{ background: "#ebf4ff" }}><span style={{ color: "#2b6cb0", fontSize: '20px' }}>₹</span></div>
                                        <div class="kpi-label">Total</div>
                                        <div class="kpi-val" id="kpi-conv">{formatIndianShort(totalAmount)}</div>
                                    </div>

                                    <div class="kpi-card" onClick={() => nextFollowUpDateLeads?.length > 0 && setShowTodayFollowup(true)}>
                                        <div class="kpi-accent" style={{ background: "#6b46c1" }}></div>
                                        <div class="kpi-icon-wrap" style={{ background: "#f5f0ff" }}><i class="pi pi-clock" style={{ color: "#6b46c1", fontSize: '20px' }}></i></div>
                                        <div class="kpi-label">Follow-ups</div>
                                        <div class="kpi-val" id="kpi-conv">{nextFollowUpDateLeads?.length}</div>
                                        <div class="kpi-sub">Pending today</div>
                                    </div>

                                    <div class="kpi-card" >
                                        <div class="kpi-accent" style={{ background: "#22863a" }}></div>
                                        <div class="kpi-icon-wrap" style={{ background: "#e8f8ed" }}><i class="pi pi-check-circle" style={{ color: "#22863a", fontSize: '20px' }}></i></div>
                                        <div class="kpi-label">Converted</div>
                                        <div class="kpi-val" id="kpi-conv">{disbursementLoanData?.count}</div>
                                    </div>
                                </div>*/}

                                <div className="kpi-row-third">
                                    {selectedStatus && (
                                        <div
                                            className="kpi"
                                            style={{ borderLeftColor: "#999", cursor: "pointer", opacity: 0.7 }}
                                            onClick={() => {
                                                setSelectedStatus(null);
                                                setShowTodayFollowup(false);
                                                setShowTodayLeads(false);
                                            }}
                                        >
                                            <div className="kpi-lbl">✕ Clear filter</div>
                                            <div className="kpi-val">Show all</div>
                                        </div>
                                    )}
                                    <div
                                        className="kpi "
                                        style={{
                                            borderLeftColor: OrderStatusColors[2],
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            setSelectedStatus(null);
                                            setShowTodayFollowup(false);
                                            setShowTodayLeads(true);
                                        }}
                                    >
                                        <div className="kpi-lbl">Today Leads - {todayLeads?.length}</div>
                                        <div className="kpi-val">₹{formatIndianShort(todayLeadsAmount)}</div>
                                    </div>

                                    <div
                                        className="kpi cursor-pointer"
                                        style={{
                                            borderLeftColor: OrderStatusColors[3],
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            if (nextFollowUpDateLeads?.length > 0) {
                                                setSelectedStatus(null);
                                                setShowTodayLeads(false);
                                                setShowTodayFollowup(true);
                                            }
                                        }}
                                    >
                                        <div className="kpi-lbl">Today Follow-ups</div>
                                        <div className="kpi-val">{nextFollowUpDateLeads?.length}</div>
                                    </div>
                                    {/*<div
                                        className="kpi"
                                        style={{
                                            borderLeftColor: OrderStatusColors[4],
                                        }}
                                    >
                                        <div className="kpi-lbl">Converted</div>
                                        <div className="kpi-val">{disbursementLoanData?.count}</div>
                                    </div>*/}
                                    {resultNew.map((resultItem, index) => (
                                        <div
                                            className="kpi"
                                            style={{
                                                borderLeftColor: OrderStatusColors[index],
                                                cursor: "pointer",
                                                outline: selectedStatus === resultItem.status
                                                    ? `2px solid ${OrderStatusColors[index]}`
                                                    : "none",
                                                opacity: selectedStatus && selectedStatus !== resultItem.status ? 0.45 : 1,
                                                transition: "opacity 0.2s, outline 0.2s",
                                            }}
                                            onClick={() => {
                                                setShowTodayLeads(false);
                                                setShowTodayFollowup(false);

                                                setSelectedStatus(prev =>
                                                    prev === resultItem.status ? null : resultItem.status
                                                );
                                            }}
                                        >
                                            <div className="kpi-lbl">{resultItem.status} - {resultItem.count}</div>
                                            <div className="kpi-val">₹{formatIndianShort(resultItem.amount)}</div>
                                        </div>
                                    ))}
                                </div>
                                <p className="text-md" style={{ color: "red" }}> * Note: Please Use Filters To Find Or Sort Leads Based On Your Requirement</p>
                                {showFilters && (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            marginTop: 5,
                                            marginBottom: 5,
                                        }}
                                    >
                                    <div className="row">
                                        <div className="col-md mb-2">
                                            <InputText
                                                type="text"
                                                value={globalFilterValue}
                                                onChange={onGlobalFilterChange}
                                                placeholder="Keyword Search"
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                        <div className="col-md mb-2">
                                            <Dropdown
                                                style={{ width: "100%" }}
                                                options={searchByStatusData}
                                                value={searchByStatus}
                                                onChange={(e) => {
                                                    setSearchByStatus(e.value);
                                                }}
                                            />
                                        </div>
                                        {/*<div className="col-md mb-2">
                                            <Dropdown
                                                style={{ width: "100%" }}
                                                options={userLeadStatus}
                                                value={selectedUserLeadStatus}
                                                placeholder="Select Status"
                                                onChange={(e) => {
                                                    setSelectedUserLeadStatus(e.value);
                                                }}
                                            />
                                        </div>*/}
                                        <div className="col-md mb-2">
                                            <Dropdown
                                                style={{ width: "100%" }}
                                                options={recordTypeSelection}
                                                value={recordTypeValue}
                                                placeholder="Select Record Type"
                                                onChange={(e) => {
                                                    setRecordTypeValue(e.value);
                                                }}
                                            />
                                        </div>
                                        <div className="col-md mb-2">
                                            <Calendar
                                                value={startDateValue}
                                                onChange={(e) => {
                                                    const start = e.value;
                                                    setStartDateValue(start);

                                                    if (!endDateValue) {
                                                        setEndDateValue(new Date()); // default today
                                                    }
                                                }}
                                                dateFormat="dd/mm/yy"
                                                placeholder="Start Date"
                                                maxDate={endDateValue ? endDateValue : new Date()}
                                                showIcon
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                        <div className="col-md mb-2">
                                            <Calendar
                                                value={endDateValue}
                                                onChange={(e) => setEndDateValue(e.value)}
                                                dateFormat="dd/mm/yy"
                                                placeholder="End Date"
                                                minDate={startDateValue}
                                                showIcon
                                                style={{ width: "100%" }} />
                                        </div>


                                        <div className="col-md mb-2">
                                            <Dropdown
                                                style={{ width: "100%" }}
                                                value={userDataFilter}
                                                onChange={(e) => {
                                                    handleTelecallerDepartment(e.value)
                                                }}
                                                options={userDataIds}
                                                optionLabel="label"
                                                placeholder="Select User"
                                            />
                                        </div>

                                    </div>

                                            

                                </div>
                                )}

                                <div class="sec-hdr">
                                    <div class="sec-ico">
                                        📥
                                    </div>
                                    <div>
                                        <div class="sec-title">{userDataFilterInfo[0]?.label}</div>
                                    </div>
                                </div>

                                <div className="dataview-demo">
                                    <div className="card leadList">
                                        <DataTable
                                            value={tableData}
                                            // lazy
                                            dataKey="id"
                                            scrollable
                                            scrollHeight="400px"
                                            first={first}   // ✅ THIS FIXES YOUR ISSUE
                                            onPage={(e) => setFirst(e.first)} // ✅ also required
                                            paginator
                                            paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                            rows={rows}
                                            rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                                            loading={loadingMore}
                                            className="p-datatable-customers client-table-design"
                                            resizableColumns
                                            columnResizeMode="fit"
                                            filters={filters}
                                            onFilter={onFilter}
                                            // filterDisplay="row"
                                            globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                                            stripedRows
                                        >
                                            <Column
                                                header="#"
                                                resizeable={false}
                                                className="product-category table-design"
                                                body={(data, options) => options.rowIndex + 1}
                                            ></Column>
                                            <Column
                                                field="View"
                                                header="View"
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <div className="action-cell">

                                                        <Link
                                                            to="/lead-form-telecaller-team-admin-create"
                                                            state={{
                                                                rowData,
                                                                listState: {
                                                                    products,
                                                                    first,
                                                                    rows
                                                                }
                                                            }}
                                                            className="act-btn act-view"

                                                        ><i className="pi pi-pencil"></i>
                                                        </Link>

                                                        <div
                                                            className="act-btn act-call"
                                                            onClick={() => {
                                                                window.location.href = `tel:${rowData?.lead?.mobileNo}`;
                                                            }}
                                                        >
                                                            <i className="pi pi-phone"></i>
                                                        </div>

                                                        <a
                                                            href={`https://wa.me/91${rowData?.lead?.mobileNo}?text=${encodeURIComponent(
                                                                `Hello ${rowData?.lead?.name}, thank you for your interest.`
                                                            )}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="act-btn act-whatsapp"
                                                        >
                                                            <i className="pi pi-whatsapp"></i>
                                                        </a>
                                                        <div
                                                            title="Pabbly Lead"
                                                            className={
                                                                rowData?.lead?.pabblyResponseMessageId
                                                                    ? "act-btn act-whatsapp"
                                                                    : "act-btn act-red"
                                                            }
                                                        >
                                                            {rowData?.lead?.pabblyResponseMessageId ? (
                                                                <i className="pi pi-check"></i>
                                                            ) : (
                                                                <i className="pi pi-times"></i>
                                                            )}
                                                        </div>

                                                        <div
                                                            title="MCube Call"
                                                            className="act-btn act-call"
                                                            onClick={() => handleMcubeCall(rowData)}
                                                        >
                                                            <i className="bi bi-telephone-outbound-fill"></i>
                                                        </div>
                                                    </div>
                                                )}
                                            ></Column>
                                            {/*<Column
                        field="loanFile"
                        header="Loan File"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/view-loan-file"}
                            state={rowData?.lead}
                            className="move-btn-medium move-btn-green center-text"
                          >
                            Loan File <i className="bi bi-eye"></i>
                          </Link>
                        )}
                      ></Column>*/}
                                            {/*<Column
                                                field="status"
                                                header="Status"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span className="colored_with_bg1">
                                                        {(rowData?.status)}
                                                    </span>
                                                )}
                                            ></Column>*/}
                                            <Column
                                                field="dateOfLead"
                                                header="Date Of Lead"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span className="colored3">
                                                        {formatDate(rowData.lead?.dateOfLead)}
                                                    </span>
                                                )}
                                            ></Column>

                                            <Column
                                                field="name"
                                                header="Name"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span className="colored4">
                                                        {rowData?.lead?.name}
                                                    </span>
                                                )}
                                            ></Column>
                                            <Column
                                                field="mobileNo"
                                                header="Mobile No"
                                                style={{ minWidth: '120px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span className="colored5">
                                                        {rowData.lead?.mobileNo}
                                                    </span>
                                                )}
                                            ></Column>
                                            <Column
                                                field="typeOfLead"
                                                header="Type Of Lead"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span className="colored_with_bg2">
                                                        {rowData?.lead?.typeOfLead ? replaceUnderscoresWithSpacesAndUpperCase(rowData?.lead?.typeOfLead) : ""}

                                                    </span>
                                                )}
                                            ></Column>
                                            <Column
                                                field="amount"
                                                header="Amount"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span className="colored1">
                                                        {rowData.lead?.amount?.toLocaleString("en-IN")}
                                                    </span>
                                                )}
                                            ></Column>
                                            <Column
                                                field="queries"
                                                header="Telecaller Remark"
                                                style={{ minWidth: '200px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span>
                                                        {rowData.lead?.queries}
                                                    </span>
                                                )}
                                            ></Column>
                                            <Column
                                                field="address"
                                                header="Address"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span>
                                                        {rowData.lead?.address}
                                                    </span>
                                                )}
                                            ></Column>
                                            <Column
                                                field="source"
                                                header="Source"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span className="colored6">
                                                        {rowData.lead?.source}
                                                    </span>
                                                )}
                                            ></Column>

                                            <Column
                                                field="followUpOn"
                                                header="Follow Up On"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => {
                                                    const followUpDate = rowData?.leadInfoList?.find(
                                                        item => item.keyName === "nextFollowUpDate"
                                                    )?.dateValue;


                                                    return (
                                                        <span>
                                                            {followUpDate ? formatDate(followUpDate) : "N/A"}
                                                        </span>
                                                    );
                                                }
                                                }
                                            ></Column>

                                            {/*<Column
                                                field="status"
                                                header="Status"
                                                style={{ minWidth: '100px' }}
                                                className="product-category table-design"
                                                body={(rowData) => (
                                                    <span>
                                                        {rowData.lead?.status === "RECEIVE" ? "New Lead" : rowData.lead?.status}
                                                    </span>
                                                )}
                                            ></Column>*/}


                                            {/*<Column
                        field="Doc"
                        header="Doc View"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/view-lead-document"}
                            state={rowData?.lead}
                            className="move-btn-medium move-btn-green center-text"
                          >
                            Doc View <i className="bi bi-eye"></i>
                          </Link>
                        )}
                      ></Column>*/}

                                        </DataTable>
                                    </div>
                                    <DataScroller
                                        ref={ds}
                                        value={products}
                                        itemTemplate={itemTemplate}
                                        rows={5}
                                        loader
                                    // footer={footer} 
                                    // header="Click Load Button at Footer to Load More" 
                                    />
                                    <div
                                        className="flex justify-content-center fixed "
                                        style={{ bottom: 30, left: 20 }}
                                    >
                                        <Button
                                            type="text"
                                            icon="pi pi-plus"
                                            // label="More"
                                            onClick={loadMore} // Update this to trigger `getData`
                                        />
                                    </div>
                                    {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
